


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import transitionServices from '@/services/transition-services';
import formatNumber from '@/shared/filters/format-number';
import RoutingModal from './RoutingModal.vue';
import utility from '@/utility/utility';
import VueGallery from 'vue-gallery';
import packageImageServices from '@/services/package-image-service';
@Component({
    components: {
        'routing-modal': RoutingModal,
        'gallery': VueGallery
    }
})
export default class ListTransition extends Vue {
    @Prop({default: {}})
    private listItem: any;
    private routingData: any;
    private isShowModal = false;
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };
    private imgIndex: any = null;
    private imagePaths: any[] = [];
    private async viewDetail(item: any) {
        
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private async printDetail(id) {
        const result =  await transitionServices.getPrintDetail(id);
        if (result && result.data && result.data.status === 200) {
            utility.print_transaction_v2(result.data.data);
        }
    }

    private openRoutingModal(routing) {
        this.routingData = routing ? JSON.parse(routing) : [];
        this.isShowModal = true;
    }
    
    private onCloseModal() {
        this.isShowModal = false;
    }

    private async openImageGallery(id) {
        const result = await packageImageServices.getList(1, 1000, [{
                column: 'TransactionID',
                value: id,
                condition: 'equal'
            }], [])
        if (result && result.status === 200 && result.data.data) {
            const bill_files = result.data.data.filter(x => x.Group === 1);
            this.imagePaths = bill_files.map(p => { return p.Path });
            if (bill_files.length > 0) {
                this.imgIndex = 0;
            }
        }
    }
}
